import { createStore, applyMiddleware } from 'redux';

import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';
import rootSaga from '../redux/sagas';
import rootReducer from '../redux/reducers';
//Redux persist imports
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import createEncryptor from 'redux-persist-transform-encrypt';
import { checkForStaleStore, checkIfPAApp } from 'utils';
import { REDUX_STORE } from 'assets/Constants';

const encryptor = createEncryptor({
  secretKey: 'my-super-secret-key' /**@TODO Need to add a Encryption key */,
  onError: function(error) {
    console.error('Error in store encryption ::', error);
  },
});

const isPAApp = checkIfPAApp();
const composeEnhancers = composeWithDevTools({});
const sagaMiddleware = createSagaMiddleware();

const isDebugMode = process.env.REACT_APP_DEBUG_MODE === 'true';

let blacklistReducers = [];
// if (isPAApp) {
//   blacklistReducers.push('user');
// }

const persistConfig = {
  key: REDUX_STORE.PERSIST_STORE_NAME,
  storage,
  blacklist: blacklistReducers,
  transforms: [encryptor],
};
const persistedReducer = persistReducer(persistConfig, rootReducer);

export default function configureStore() {
  let store = createStore(
    persistedReducer,
    isDebugMode
      ? composeEnhancers(applyMiddleware(sagaMiddleware))
      : applyMiddleware(sagaMiddleware)
  );

  /**
   * Clear the old redux store if expiry time has passed,
   */
  checkForStaleStore();
  /**/
  sagaMiddleware.run(rootSaga);

  let persistor = persistStore(store);

  return { store, sagaMiddleware, persistor };
}
